import { render, staticRenderFns } from "./ApexReferralChart.vue?vue&type=template&id=7b028e28&scoped=true"
import script from "./ApexReferralChart.vue?vue&type=script&lang=js"
export * from "./ApexReferralChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b028e28",
  null
  
)

export default component.exports